import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'

import AppContainer from './UI/AppContainer'
import store from './store'
import * as serviceWorker from './serviceWorker'

const container = document.getElementById('root')
const rootContainer = ReactDOM.createRoot(container)

rootContainer.render(
  <Provider store={store}>
    <React.StrictMode>
      <AppContainer />
    </React.StrictMode>
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
